module.exports = __webpack_public_path__ + "static/subset-UniNeueThin-Italic-4e5ae16b5ee2b7557d288c6ab7b4e1c2.woff2";